import { ListButton as ReactAdminListButton, ListButtonProps } from 'react-admin'

export const ListButton = (props: ListButtonProps): JSX.Element => {
  return <ReactAdminListButton {...props} size='medium' />
}
